import util from "./_util";

const { request } = util;

export default {
  //发布成果故事
  publishFruit(data) {
    return request.post("/achieve/add", data);
  },
  //分页查询
  queryFruitList(params) {
    // params["uid"] = uid;
    return request.get("/achieve/pager_list", {
      params,
    });
  },
  //查询成果详情
  queryFruitDetail(params) {
    return request.get("/achieve/get_info?id=" + params);
  },
  //点赞成果
  thumbFruit(data) {
    return request.post("/achieve/prize", data);
  },
};
